"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainName = exports.rotate = exports.degreesToRadians = exports.generateStringOfNumbers = exports.filterInPlace = exports.clearMainList = exports.clearEmptyLast = exports.isInPosition = exports.getRandomPosition = exports.emitSocket = exports.getKeyByValue = exports.getRandomItem = exports.getRandomNumberBetween = exports.getRandomInt = exports.distanceBetween = void 0;
const constants_1 = __importDefault(require("../shared/constants"));
const notepack = require('notepack.io');
function distanceBetween(x1, y1, x2, y2) {
    const dx = x1 - x2;
    const dy = y1 - y2;
    return Math.sqrt(dx * dx + dy * dy);
}
exports.distanceBetween = distanceBetween;
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
exports.getRandomInt = getRandomInt;
function getRandomNumberBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
exports.getRandomNumberBetween = getRandomNumberBetween;
function getRandomItem(array) {
    return array[Math.floor(Math.random() * array.length)];
}
exports.getRandomItem = getRandomItem;
function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}
exports.getKeyByValue = getKeyByValue;
function emitSocket(socket, action, message) {
    let notepackMSG;
    if (message) {
        notepackMSG = notepack.encode([action, message]);
    }
    else {
        notepackMSG = notepack.encode([action]);
    }
    // If player leaves right before this, game will crash if error not handled
    try {
        socket.send(notepackMSG, true, true);
    }
    catch (error) {
        console.log('Emit Socket Error', error);
    }
}
exports.emitSocket = emitSocket;
// export function getRandomPosition(minX: number, maxX: number, minY: number, maxY: number): { x: number, y: number } {
//     return {
//         x: getRandomInt(minX, maxX),
//         y: getRandomInt(minY, maxY)
//     }
// }
function getRandomPosition(coords) {
    return {
        x: getRandomInt(coords.SPAWN_MIN_X, coords.SPAWN_MAX_X),
        y: getRandomInt(coords.SPAWN_MIN_Y, coords.SPAWN_MAX_Y)
    };
}
exports.getRandomPosition = getRandomPosition;
function isInPosition(position, coords) {
    return position.x >= coords.SPAWN_MIN_X && position.x <= coords.SPAWN_MAX_X && position.y >= coords.SPAWN_MIN_Y && position.y <= coords.SPAWN_MAX_Y;
}
exports.isInPosition = isInPosition;
function clearEmptyLast(list) {
    let last = list[list.length - 1];
    while ((last === null || last === undefined || (typeof last === 'number' && last === 0)) && list.length > 0) {
        list.pop();
        last = list[list.length - 1];
    }
}
exports.clearEmptyLast = clearEmptyLast;
function clearMainList(list) {
    let last = list[list.length - 1];
    while ((Array.isArray(last) && last.length == 0) || last === null || last === undefined) {
        list.pop();
        last = list[list.length - 1];
    }
}
exports.clearMainList = clearMainList;
function filterInPlace(array, fn) {
    let from = 0, to = 0;
    while (from < array.length) {
        if (fn(array[from])) {
            array[to] = array[from];
            to++;
        }
        from++;
    }
    array.length = to;
}
exports.filterInPlace = filterInPlace;
function generateStringOfNumbers(length) {
    let numString = '';
    for (let i = 0; i < length; i++) {
        numString += Math.floor(Math.random() * 10);
    }
    return numString;
}
exports.generateStringOfNumbers = generateStringOfNumbers;
function degreesToRadians(degrees) {
    return degrees * (Math.PI / 180);
}
exports.degreesToRadians = degreesToRadians;
function rotate(point, angle) {
    var x = point.x;
    var y = point.y;
    point.x = (x * Math.cos(angle)) - (y * Math.sin(angle));
    point.y = (x * Math.sin(angle)) + (y * Math.cos(angle));
    return point;
}
exports.rotate = rotate;
function getDomainName() {
    let domainName = constants_1.default.GAME_MODE_MAP.find((gameMode) => gameMode.gameName === 'mainportal').domain;
    let singleGameName;
    if (process.env.SINGLE_GAME_NAME) {
        singleGameName = process.env.SINGLE_GAME_NAME;
    }
    else if (constants_1.default.SINGLE_GAME_NAME) {
        singleGameName = constants_1.default.SINGLE_GAME_NAME;
    }
    if (singleGameName) {
        domainName = constants_1.default.GAME_MODE_MAP.find((gameMode) => gameMode.gameName === singleGameName).domain;
    }
    return domainName;
}
exports.getDomainName = getDomainName;
